export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '2f322534-2dfb-49d9-89ee-97eb2f7108d5';
export const MODAL_CLOSE_SEC = 2.5;